<template>
      <div class="tile is-child box">
        <div class="tags has-addons">
          <span class="tag  is-medium">Config</span>
          <span class="tag is-warning is-medium">Change Prefix</span>
        </div>
        <div class="notification is-info">You can only perform that action, if you are the owner of the Guild!</div>
        <div class="field has-addons">
          <div class="control">
            <input class="input" type="text" placeholder="New Prefix" v-model="bindNewPrefix">
          </div>
          <div class="control">
            <a class="button is-dark" @click="setPrefix()">
              Change
            </a>
          </div>
        </div>
      </div>
</template>

<script>
export default {
  name: 'MemberInfo',
  data: function() {
    return {
      bindNewPrefix: ''
    }
  },
  methods: {
    setPrefix(prefix) {
      
      this.axios.get(this.$store.state.adress + '/changePrefix?token=' + this.$store.state.token + '&newPrefix=' + this.bindNewPrefix)
      .then((response) => {
        console.log(response.data);
        this.memberinfo = response.data.object;
      })
    }
  }
}
</script>

<style>
@import "~bulma/css/bulma.css";
</style>